// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDviSR39lEb75rSA9NP06Yz0QOtytyHuls",
  authDomain: "koffer-3501a.firebaseapp.com",
  projectId: "koffer-3501a",
  storageBucket: "koffer-3501a.firebasestorage.app",
  messagingSenderId: "885913810006",
  appId: "1:885913810006:web:5cd168fe8a67d9fc0a37f7",
  measurementId: "G-4SSV9KJK45"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
const analytics = getAnalytics(app);
export const storage = getStorage(app);

export const auth = getAuth(app);
export default app